import { ChildModel, ModelBase } from 'store/model-base';
import { E911Address } from './address';

export class E911AddressValidation extends ModelBase {
    public static storeName: string = 'e911AddressValidation';

    public enteredAddress: E911Address;
    public isValid: boolean;
    public suggestedAddresses: E911Address[];

    public static create<T extends ModelBase>(data: ApiResponse): T {
        if (!data.isValid) {
            data.isValid = false;
        }

        return super.create<T>(data);
    }

    protected static get hasOne(): ChildModel[] {
        return [{
            attrName: 'enteredAddress',
            model: E911Address
        }];
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'suggestedAddresses',
            model: E911Address
        }];
    }
}
